import { createFileRoute } from "@tanstack/react-router";

import { ScrapeScreen } from "@/screens/Scrape";

export const Route = createFileRoute("/_authenticated/(admin)/admin/scrape")({
  loader: ({ context: { trpcQueryUtils } }) => {
    trpcQueryUtils.scrape.list.prefetch().catch(console.error);
  },
  component: ScrapeScreen,
});
